<div class="nav">
  <ul>
    <li id="promob-logo-container">
      <img src="../../../assets/Images/promob-logo.png" alt="promob_logo" id="promob-logo">
    </li>
    <li *ngFor="let routerLink of routerLinks" [routerLink]="routerLink.route" routerLinkActive="selected-item"
      [routerLinkActiveOptions]="routerLink.routerLinkActiveOptions" [ngClass]="{'last-nav-item': routerLink.isLastItem}">
      <mat-icon aria-hidden="false" class="icon">{{routerLink.iconName}}</mat-icon>
      <a>{{routerLink.description}}</a>
    </li>
  </ul>
</div>